import React from 'react';
import axios from 'axios';
import { user_token } from '../../../services/Auth';
import LifeHabits from './LifeHabits';

var token = localStorage.getItem(user_token);

export default class GetMedicalRecord extends React.Component {
  state = {
    consulta: []
  }

  componentDidMount() {
    axios.get(`http://api-convida.herokuapp.com/user/${this.props.user_id}`, {headers: {'x-access-token': token}})
      .then(res => {
        const consulta = res.data;
        this.setState({ consulta });
      })
  }

  render() {
    return (
      <ul>
        { this.state.consulta.map(details => 
        <>
          <p id="RI-Title-Cadastro-Paciente" >CPF do(a) Médico(a): </p><p>{details.medical_record.professional_name}</p>
          <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Médico(a): </p><p>{details.medical_record.professional_cpf}</p>
          <p id="RI-Title-Cadastro-Paciente" >Data: </p><p>{details.medical_record.date}</p>
          <p id="RI-Title-Cadastro-Paciente" >Antecedentes: </p><p>{details.medical_record.antecedents}</p>
          <p id="RI-Title-Cadastro-Paciente" >Histórico Familiar: </p><p>{details.medical_record.family_history}</p>
          <p id="RI-Title-Cadastro-Paciente" >Queixas Atuais: </p><p>{details.medical_record.current_complaints}</p>
          <p id="RI-Title-Cadastro-Paciente" >Medicamentos em Uso: </p><p>{details.medical_record.medications_in_use}</p>
          <p id="RI-Title-Cadastro-Paciente" >Exame Física: </p><p>{details.medical_record.physical_exam}</p>
          <p id="RI-Title-Cadastro-Paciente" >Exames Complementares: </p><p>{details.medical_record.complementary_exam}</p>
          <p id="RI-Title-Cadastro-Paciente" >Diagnóstico: </p><p>{details.medical_record.diagnosis}</p>
          <p id="RI-Title-Cadastro-Paciente" >Pedido: </p><p>{details.medical_record.conduct}</p>
          <p id="RI-Title-Cadastro-Paciente" >Medicamentos Prescritos: </p><p>{details.medical_record.prescripted_drugs}</p>
          <p id="RI-Title-Cadastro-Paciente" >Exames Pedido: </p><p>{details.medical_record.requested_exams}</p>
          <p id="RI-Title-Cadastro-Paciente" >Referência Médica: </p><p>{details.medical_record.medical_referral}</p>
          <p id="RI-Title-Cadastro-Paciente" >Observações: </p><p>{details.medical_record.note}</p><br></br>
          <h3>Hábitos de Vida</h3>
          <LifeHabits life={details._id}/>
        </>)}
      </ul>
    )
  }
}